import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { StudiesTab } from './StudiesTab';
import { Participation } from '@app/api';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useMatch, useNavigate } from 'react-router-dom';
import { ParticipationColumn } from '../../components/useParticipationsByStatus';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  globalContainer: {
    width: '100%',
    padding: 0,
    backgroundColor: theme.colors.white,

    '& button': {
      margin: [0, theme.marginBase * 3, 0, 0],
      padding: [0, 0, theme.marginBase * 2, 0],
    },

    '& .MuiTabs-flexContainer': {
      padding: [0, theme.marginBase * 2],
    },
  },
}));

interface Props {
  participations: Record<ParticipationColumn, Participation[]>;
}

export const StudiesBar = ({ participations }: Props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const match = useMatch('/studies/:name');
  const path = match?.params?.name || '';

  const handleTabChange = useCallback(
    (_: any, path: string) => navigate(path),
    [navigate],
  );

  return (
    <div className={classes.globalContainer}>
      <Tabs
        value={path}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons
        aria-label="Menu"
      >
        <Tab
          value="past"
          label={
            <StudiesTab
              title={t('studies.header.past')}
              color="purple"
              number={participations.past ? participations.past.length : 0}
            />
          }
        />
        <Tab
          value="confirmed"
          label={
            <StudiesTab
              title={t('studies.header.confirmed')}
              color="green"
              icon="ri-calendar-event-line"
              number={
                participations.confirmed ? participations.confirmed.length : 0
              }
            />
          }
        />
        <Tab
          value="accepted"
          label={
            <StudiesTab
              title={t('studies.header.accepted')}
              color="red"
              indicator={
                participations.accepted && participations.accepted.length !== 0
              }
              number={
                participations.accepted ? participations.accepted.length : 0
              }
            />
          }
        />
        <Tab
          value="applied"
          label={
            <StudiesTab
              title={t('studies.header.applied')}
              color="yellow"
              number={
                participations.applied ? participations.applied.length : 0
              }
            />
          }
        />
        <Tab
          value="matched"
          label={
            <StudiesTab
              title={t('studies.header.matched')}
              color="blue"
              number={
                participations.invited ? participations.invited.length : 0
              }
            />
          }
        />
      </Tabs>
    </div>
  );
};
